import { atom } from 'jotai';
import { TranslateMode } from 'services/api/overseaTranslate';

const cacheKey = `@${import.meta.env.VITE_NAME}.translateToolTranslateMode`;

const translateModeAtom = atom<TranslateMode>(
  (localStorage.getItem(cacheKey) as TranslateMode) || 'GOOGLE',
);
const translateModeState = atom(
  (get) => get(translateModeAtom),
  (_, set, val: TranslateMode) => {
    set(translateModeAtom, val);
    localStorage.setItem(cacheKey, val);
  },
);

export default translateModeState;
